const getSharingToken = () => document.getElementById('sharingToken')
	? document.getElementById('sharingToken').value
	: null

export { getSharingToken }
